import { render, staticRenderFns } from "./unionTroduc.vue?vue&type=template&id=6783864b&scoped=true&"
import script from "./unionTroduc.vue?vue&type=script&lang=js&"
export * from "./unionTroduc.vue?vue&type=script&lang=js&"
import style0 from "./unionTroduc.vue?vue&type=style&index=0&id=6783864b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6783864b",
  null
  
)

export default component.exports